export const TOAST_AUTO_CLOSE: number = 3000;
export const MAX_PRODUCT_QUANTITY: number = 100;
